import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

console.log('Build Commit Hash:', environment.commitHash);

if (environment.production) {
  enableProdMode();
  console.log = () => { };
}
platformBrowserDynamic().bootstrapModule(AppModule);
